import axiosClient from "./axiosClient";

// API cấu hình giao diện app: nút GIỮA thanh tab + nút HƯỚNG DẪN trang chủ.
// App đọc file tĩnh /img/app-tab-config.json; admin sửa qua endpoint này.
const appTabConfigApi = {
    getConfig() {
        return axiosClient.get("app-tab-config");
    },
    updateConfig(payload) {
        // Gửi 1 hoặc cả 2 section, section không gửi thì backend giữ nguyên:
        //   { centerTab: { label, badgeText, badgeEnabled, openMode, screenName, link, injectUserId } }
        //   { homeGuide: { enabled, label, openMode, screenName, postId, link, injectUserId } }
        return axiosClient.put("app-tab-config", payload);
    },
};

export default appTabConfigApi;
